import { TCountryCode } from 'countries-list';
import { create } from 'zustand';

// TODO: should be called OnboardingMapState

type onboardingState = {
  countries: TCountryCode[]
  setCountries: (value: TCountryCode[]) => void
  addCountry: (value: TCountryCode) => void
  removeCountry: (value: TCountryCode) => void
  // Bucket list countries
  bCountries: TCountryCode[]
  setBCountries: (value: TCountryCode[]) => void
  addBCountry: (value: TCountryCode) => void
  removeBCountry: (value: TCountryCode) => void
};

const useOnboardingState = create<onboardingState>(set => ({
  countries: [],
  setCountries: newCountries => set({ countries: newCountries }),
  addCountry: country => set(prev => ({ countries: [...prev.countries, country] })),
  removeCountry: country => set(prev => ({ countries: prev.countries.filter(x => x !== country) })),

  bCountries: [],
  setBCountries: newCountries => set({ bCountries: newCountries }),
  addBCountry: country => set(prev => ({ bCountries: [...prev.bCountries, country] })),
  removeBCountry: country => set(prev => ({ bCountries: prev.bCountries.filter(x => x !== country) })),
}));

export default useOnboardingState;
